export default "<ion-app>\n  <app-menu></app-menu>\n  <ion-router-outlet id=\"content\"></ion-router-outlet>\n</ion-app>";